import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=54831818&"
import script from "./InvoiceTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GDownloadButton from 'shared/global/components/DownloadButton.vue'
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {GDownloadButton,VDataTable})
